"use client";

// Replaces Next.js's raw "Application error" screen when the root layout fails,
// which now happens when Strapi is unreachable and no cached page exists yet.
// Must render its own <html> and <body> because it replaces the root layout.
export default function GlobalError() {
  return (
    <html lang="en">
      <body style={{ fontFamily: "system-ui, sans-serif", margin: 0, background: "#f8f5f2" }}>
        <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: "2rem", textAlign: "center" }}>
          <div>
            <h1 style={{ fontSize: "1.5rem", marginBottom: "0.75rem" }}>We&apos;ll be right back</h1>
            <p style={{ marginBottom: "1.5rem" }}>
              The page is taking a moment to load. Please try again shortly, or call (888) 612-1308.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{ padding: "0.75rem 1.5rem", border: 0, borderRadius: "0.5rem", background: "#0054a6", color: "#fff", fontWeight: 700, cursor: "pointer" }}
            >
              Try again
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
